import { render, staticRenderFns } from "./BusinessGuideCardWrapper.vue?vue&type=template&id=66cafc08&scoped=true"
import script from "./BusinessGuideCardWrapper.vue?vue&type=script&lang=js"
export * from "./BusinessGuideCardWrapper.vue?vue&type=script&lang=js"
import style0 from "./BusinessGuideCardWrapper.vue?vue&type=style&index=0&id=66cafc08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cafc08",
  null
  
)

export default component.exports